import { Box, Tab, Tabs } from '@mui/material';
import { visibleLanguages } from '../../config/quill-text-editor-settings';

export function a11yProps(index: number) {
  return {
    id: `language-tab-${index}`,
    'aria-controls': `language-tabpanel-${index}`,
  };
}

interface LanguageTabsProps {
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

export const LanguageTabs = ({ value, onChange }: LanguageTabsProps) => {
  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <Tabs
        value={value}
        onChange={onChange}
        aria-label='language tabs'
        allowScrollButtonsMobile={true}
        variant='scrollable'
      >
        {visibleLanguages.map((lang, index) => (
          <Tab key={lang.code} label={lang.label} {...a11yProps(index)} />
        ))}
      </Tabs>
    </Box>
  );
};
